(() => {
  'use strict';

  const LIFT_SELECTORS = [
    '.xo-home-hero__title',
    '.xo-home-hero__body',
    '.xo-home-hero__actions',
    '.xo-home-category__content',
    '.xo-home-flavours__intro',
    '.xo-home-journal__head',
    '.xo-home-selection__copy',
    '.xo-collection-hero__copy',
    '.xo-collection-products__head',
    '.xo-collection-story__content',
    '.xo-product-story__copy',
    '.xo-product-related__heading',
    '.xo-eminence-editorial__inner',
    '.xo-eminence-tech__copy',
    '.xo-eminence-collection__head',
    '.xoe-engineering__content',
    '.xoe-feel__head',
    '.xoe-how__head',
    '.xoe-manifesto__copy',
    '.xoe-materials__top',
    '.xoe-what__content',
    '.xoe-bento__head',
    '.xop-features__head',
    '.xop-tech__content',
    '.xosf2__intro',
    '.xo-about__hero-content',
    '.xo-about__copy',
    '.xo-about__statement-inner',
    '.xo-about__values-head',
    '.xo-about__closing-content',
    '.xo-recycling__hero-copy',
    '.xo-recycling__intro',
    '.xo-recycling__steps-head',
    '.xo-recycling__impact-copy',
    '.xo-recycling__values-head',
    '.xo-reseller__hero-copy',
    '.xo-reseller__intro',
    '.xo-reseller__split-copy',
    '.xo-reseller__cta',
    '.xo-journal__hero-copy',
    '.xo-journal__heading',
    '.xo-article__excerpt',
    '.xo-article__body'
  ];

  const FADE_SELECTORS = [
    '.xo-benefit',
    '.xo-home-selection__media',
    '.xo-home-category__media',
    '.xo-journal-card',
    '.xo-collection-hero__media',
    '.xo-collection-product',
    '.xo-product-story__media',
    '.xo-related-card',
    '.xo-eminence-panel',
    '.xo-eminence-highlight',
    '.xo-eminence-tech__media',
    '.xoe-engineering__media',
    '.xoe-feel__card',
    '.xoe-how__step',
    '.xoe-materials__item',
    '.xoe-what__media',
    '.xoe-what__point',
    '.xoe-bento__item',
    '.xoe-bento__micro',
    '.xop-feature',
    '.xop-tech__media',
    '.xo-about__image',
    '.xo-recycling__impact-image',
    '.xo-journal__card',
    '.xo-shop-all__product'
  ];

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  if (
    reduceMotion.matches ||
    !('IntersectionObserver' in window) ||
    (window.Shopify && window.Shopify.designMode)
  ) {
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const element = entry.target;

      element.classList.remove('xo-reveal-pending');
      element.classList.add('xo-reveal-visible');

      observer.unobserve(element);
    });
  }, {
    root: null,
    rootMargin: '0px 0px -45px 0px',
    threshold: 0.05
  });

  function register(selector, type) {
    document.querySelectorAll(selector).forEach((element) => {
      if (element.classList.contains('xo-reveal-target')) return;

      const parent = element.parentElement;
      let order = 0;

      if (parent) {
        order = Array.from(parent.children)
          .filter((child) => child.matches(selector))
          .indexOf(element);
      }

      element.style.setProperty(
        '--xo-reveal-delay',
        `${Math.min(Math.max(order, 0), 3) * 75}ms`
      );

      element.classList.add(
        'xo-reveal-target',
        type === 'lift' ? 'xo-reveal-lift' : 'xo-reveal-fade',
        'xo-reveal-pending'
      );

      observer.observe(element);
    });
  }

  function initialize() {
    LIFT_SELECTORS.forEach((selector) => register(selector, 'lift'));
    FADE_SELECTORS.forEach((selector) => register(selector, 'fade'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {
      once: true
    });
  } else {
    initialize();
  }

  reduceMotion.addEventListener('change', (event) => {
    if (!event.matches) return;

    observer.disconnect();

    document.querySelectorAll('.xo-reveal-pending').forEach((element) => {
      element.classList.remove('xo-reveal-pending');
      element.classList.add('xo-reveal-visible');
    });
  });
})();
